<template>
  <div style="display: flex;">
   <v-icon>mdi-account</v-icon>
  <v-autocomplete
    :items="users"
    v-model="userSelected"
    label="Select User"
    item-text="userName"
    item-value="userId"
    dense
    style="z-index:99"
    @change="handleChange"
  />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userSelected: null,
      users: [
        // {
        //   userId: 2,
        //   userName: "Swaroop",
        // },
        // { userId: 3, userName: "Srinadh" },
      ],
    };
  },
  mounted(){
    console.log("routed_machineID in machine select", this.routed_machineID,this.inputData);
    let endPoint = "getsiteandprimarycustomerusers";

    let config = {
      method: "get",
      url: `${this.$config.backend_url}/${endPoint}`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    axios(config).then((response) => {
      this.users = response.data.data || [];

       });
  },
  
  methods: {
    handleChange() {
      // The `userSelected` here directly holds the value of "userId"
      const userId = this.userSelected;
      const selectedUser = this.users.find((user) => user.userId === userId);

      if (selectedUser) {
        const userName = selectedUser.userName;
        this.$emit("user-selected", { userId, userName });
        console.log("aaaaaaaaaaaaaaaaa", userId, userName);
      }
    },
  },
};
</script>
